import { smoothScrollTo } from './utilities'

document.addEventListener('DOMContentLoaded', () => {
    const linkElements = document.querySelectorAll('[data-scroll-to]');

    linkElements && linkElements.forEach(element => {
        element.addEventListener('click', () => {
            const target = document.querySelector(`#${element.dataset.scrollTo}`);
            target && smoothScrollTo(target)
        })
    })

});